<template>
  <div>
    <the-nav-bar :title="$t('createPost.trader')" />
    <div class="body-wrapper">
      <md-field :brief="$t('customize.traderBrief')">
        <div class="check-list">
          <div
            class="check-item row-align-center"
            v-for="item in options"
            :key="item.value"
            @click="onCheck(item)"
          >
            <div class="check-item-left">
              <svg class="icon">
                <use
                  :xlink:href="
                    check[item.value]
                      ? '#icon-trader-selected'
                      : '#icon-trader-unselected'
                  "
                />
              </svg>
            </div>
            <div class="check-item-right">{{ item.label }}</div>
          </div>
        </div>
        <!-- <md-check-list
          v-model="selected"
          :options="options"
          iconPosition="left"
          icon="icon-trader-selected"
          icon-inverse="icon-trader-unselected"
          :icon-svg="true"
        ></md-check-list> -->
      </md-field>
      <div class="info">
        <ul>
          <li v-for="(remark, i) in remarks" :key="i">{{ remark }}</li>
        </ul>
      </div>
      <md-button
        :type="isSubmitting ? 'disabled' : 'primary'"
        @click="onSubmit"
      >
        <span>{{ $t('common.confirm') }}</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { CheckList, Button, Field } from 'mand-mobile';
import { mapState } from 'vuex';
export default {
  components: {
    TheNavBar,
    [CheckList.name]: CheckList,
    [Button.name]: Button,
    [Field.name]: Field,
  },
  data() {
    return {
      selected: [],
      check: {},
      isSubmitting: false,
    };
  },
  computed: mapState({
    traders: state => state.adTemp.traders,
    userInfo: state => state.userInfo,
    navLang: state => state.navLang,
    navLangMain: state => state.navLangMain,
    property: state => state.settings.property,
    options() {
      const { hasCertified, isOversea } = this.userInfo;
      const property = this.property
        .map(item => {
          return {
            value: item.id,
            label: item[this.navLang],
            default: item.default,
            onlyShield: item.isLandun,
            onlyOversea: item.isOversea,
          };
        });
      const list = [];
      property.forEach(item => {
        if (item.onlyShield) {
          if (hasCertified) {
            list.push(item);
          }
        } else {
          if (isOversea && item.onlyOversea) {
            list.push(item);
          }
          if (!isOversea && !item.onlyOversea) {
            list.push(item);
          }
        }
      });
      return list;
    },
    remarks() {
      return this.property
        .map(item => {
          return item[`${this.navLang}Remark`];
        })
        .filter(remark => !!remark);
    },
  }),
  mounted() {
    this.options.forEach(item => {
      this.$set(this.check, item.value, item.default);
    });
    this.traders.forEach(v => {
      this.check[v] = true;
    });
  },
  methods: {
    onSubmit() {
      this.isSubmitting = true;
      let arr = [];
      Object.entries(this.check).forEach(([key, checked]) => {
        if (checked) {
          arr.push(key);
        }
      });
      this.$store.commit('setCreateTemp', {
        traders: arr,
      });
      this.$nextTick(() => {
        this.isSubmitting = false;
        this.$router.back();
      });
    },
    onCheck(option) {
      // if (option.default) {
      //   return Dialog.alert({ 
      //     icon: 'icon-negative',
      //     iconSvg: true,
      //     content: this.$t('createPost.safeAlert'),
      //     confirmText: this.$t('common.known'),
      //   });
      // }
      this.check[option.value] = !this.check[option.value];
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 0 0 40vw;

  .md-field {
    padding: 0;
  }

  .info {
    margin: 4.8vw;
    font-size: 3.2vw;
    line-height: 1.5;
    color: color-text-gray;

    & > ul {
      margin: 0;
      padding: 0;
    }
  }

  .md-button {
    margin: 14.4vw auto 0;
    width: 90.4vw;
  }

  & >>> {
    .md-field-header {
      margin: 4.8vw;
    }

    .md-cell-item {
      padding: 0 4.8vw;

      &:nth-child(even) {
        background: #F8FBFC;
      }
    }

    .md-cell-item-body {
      min-height: 17.07vw;

      &:before {
        content: none;
      }
    }
  }
}

.check-item {
  padding: 0 4.8vw;
  height: 17.07vw;

  &:nth-child(even) {
    background: #F8FBFC;
  }

  .check-item-left {
    margin-right: 4.26667vw;

    .icon {
      width: 4.26667vw;
      height: 4.26667vw;
      line-height: 4.26667vw;
    }
  }

  .check-item-right {
    font-size: 4.26667vw;
    line-height: 1.2;
  }
}
</style>
